import Vue from "vue"

import "./plugins/axios"
import "./plugins/buefy"
import "./plugins/moment"
import "./plugins/timeago"
import "./plugins/components"
import utils from "./mixins/utils"
import moneyHelpers from "./mixins/moneyHelpers"
import "./errorHandler"

import App from "./App.vue"
import router from "./router"
import store from "./store"

Vue.config.productionTip = false
Vue.mixin(utils)
Vue.mixin(moneyHelpers)

store.dispatch("auth/check")

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
